import { useCallback, useRef, useState } from 'react';

interface AccordionState {
  isOpen: boolean;
  previousState: boolean;
}

interface UseAccordionReturn {
  isOpen: boolean;
  handleClick: () => void;
  toggle: () => void;
  open: () => void;
  close: () => void;
}

export const useAccordion = (initialState = false): UseAccordionReturn => {
  const [isOpen, setIsOpen] = useState(initialState);
  const stateRef = useRef<AccordionState>({
    isOpen: initialState,
    previousState: initialState,
  });

  const handleClick = useCallback(() => {
    setIsOpen((prev) => {
      stateRef.current = {
        isOpen: !prev,
        previousState: prev,
      };
      return !prev;
    });
  }, []);

  const toggle = useCallback(() => handleClick(), [handleClick]);

  const open = useCallback(() => {
    if (!stateRef.current.isOpen) {
      setIsOpen(true);
      stateRef.current = {
        isOpen: true,
        previousState: stateRef.current.isOpen,
      };
    }
  }, []);

  const close = useCallback(() => {
    if (stateRef.current.isOpen) {
      setIsOpen(false);
      stateRef.current = {
        isOpen: false,
        previousState: stateRef.current.isOpen,
      };
    }
  }, []);

  return {
    isOpen,
    handleClick,
    toggle,
    open,
    close,
  };
};
